/* tslint:disable: no-non-null-assertion */

import {
    Injectable,
    TemplateRef,
} from '@angular/core';

import {
    ComponentType,
} from '@angular/cdk/portal';

import {
    MatDialogConfig as DialogConfig,
} from '@angular/material/dialog';

import {
    DialogService,
} from './services/dialog.service';

import {
    DialogRef,
} from './dialog.ref';

import {
    ModalFactory,
} from './factories/modal.factory';

import {
    ConfirmContainer,
} from './outlets/confirm/confirm.container';

import {
    ModalContainer,
} from './outlets/modal/modal.container';

import {
    FullwidthContainer,
} from './outlets/fullwidth/fullwidth.container';

import {
    PreviewFactory,
} from './factories/preview.factory';

import {
    PreviewContainer,
} from './outlets/preview/preview.container';

// TODO(@leandro): 100vh and 100vw not working on chrome.
//                 review it in future versions
export const FULLWIDTH_DIALOG_CONFIG: any = {
    maxWidth: '100vw',
    maxHeight: '100vh',
    width: '99vw',
    height: '99vh',
    autoFocus: false,
    panelClass: 'thm-fullwidth-dialog-pane',
};

export const PREVIEW_DIALOG_CONFIG: any = {
    disableClose: true,
    panelClass: 'thm-preview-dialog-pane',
    backdropClass: 'thm-preview-dialog-backdrop',
};

export const CONFIRM_DIALOG_CONFIG: any = {
    width: '480px',
    autoFocus: false,
    panelClass: 'thm-confirm-dialog-pane',
};

export const DEFAULT_CONFIRM_DIALOG_DATA: any = {
    cancel: { label: 'No' },
    confirm: { label: 'Yes' },
};

export const DEFAULT_MODAL_DIALOG_DATA: any = {
    cancel: { label: 'Cancel' },
    confirm: { label: 'Save' },
};

@Injectable()
export class Dialog {

    constructor(
        private _dialog: DialogService,
        private _modal: ModalFactory,
        private _preview: PreviewFactory,
    ) { }

    public openAsFullwidth<T, D = any>(
        content: ComponentType<T> | TemplateRef<T>,
        config?: DialogConfig<D>,
    ): DialogRef<T> {
        config = { ...config, ...FULLWIDTH_DIALOG_CONFIG };
        return this._dialog.open(this._modal, FullwidthContainer, content, config);
    }

    public openAsModal<T, D = any>(
        content: ComponentType<T> | TemplateRef<T>,
        config?: DialogConfig<D>,
    ): DialogRef<T> {
        config = { ...config, data: { ...DEFAULT_MODAL_DIALOG_DATA, ...config.data } };
        return this._dialog.open(this._modal, ModalContainer, content, config);
    }

    public openPreview<T, D = any>(
        data: any,
    ): DialogRef<T> {
        const config = { ...{ data: data }, ...PREVIEW_DIALOG_CONFIG };
        return this._dialog.open(this._preview, PreviewContainer, null, config);
    }

    public openConfirm<T>(
        content: ComponentType<T> | TemplateRef<T>,
        data: any,
    ): DialogRef<T> {
        const config = { ...{ data: { ...DEFAULT_CONFIRM_DIALOG_DATA, ...data } }, ...CONFIRM_DIALOG_CONFIG };
        return this._dialog.open(this._modal, ConfirmContainer, content, config);
    }
}
